import { useState } from "react";
import { ReactComponent as LeftIcon } from "../assets/icons/chevron-left.svg";

export function ImageListView({ images, className = "" }) {
  const [index, setIndex] = useState(0);

  const handleNext = () => {
    setIndex(index + 1);
  };

  const handlePrevious = () => {
    setIndex(index - 1);
  };
  const length = images.length;
  return (
    <div className={`relative ${className}`}>
      {images?.length > 1 && (
        <>
          <button
            className="w-7 h-7 self-center flex justify-center items-center rounded-full absolute left-0 top-0 bottom-0 bg-[rgba(255,255,255,0.50)] border border-[#ddd]"
            style={{
              backdropFilter: "blur(12px)",
            }}
            disabled={index === 0}
            onClick={handlePrevious}
          >
            <LeftIcon className="[&_path]:stroke-black w-4 h-4 rotate-180" />
          </button>
          <button
            className="w-7 h-7 self-center flex justify-center items-center rounded-full absolute right-0 top-0 bottom-0 bg-[rgba(255,255,255,0.50)] border border-[#ddd]"
            style={{
              backdropFilter: "blur(12px)",
            }}
            disabled={index === length - 1}
            onClick={handleNext}
          >
            <LeftIcon className="[&_path]:stroke-black w-4 h-4" />
          </button>
        </>
      )}
      <div className="absolute top-2 py-[3px] px-2 right-2 bg-black/50 rounded-[9px] text-white text-xs tracking-[-0.36px] poppins">
        {index + 1}/{length}
      </div>
      <img
        src={images[index]}
        className="w-full h-full object-cover rounded-[9px]"
      />
    </div>
  );
}
